import React, { useState, useEffect } from "react";
import { endPoints } from "../../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  updateData,
} from "../../../Utility/API";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";

import {
  Box,
  Grid,
  Button,
  Typography,
  IconButton,
  Tabs,
  Tab,
  Divider,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

import PageHeader from "../../../components/PageHeader";
import SectionCard from "../../../components/SectionCard";
import { tokens } from "../../../theme";
import { mono, pill, statusKind } from "../../../components/tableKit";

import AddNote from "./Addnote";
import AccountStatusDialog from "./AccountStatusDialog";
import AccountTypeDialog from "./AccountTypeDialog";
import PlayerTypeDialog from "./PlayerTypeDialog";
import KycTypeDialog from "./KycTypeDialog";
import QuestionDialog from "./QuestionDialog";
import CRSTypeDialog from "./CRSTypeDialog";
import DailyLimitTypeDialog from "./DailyLimitTypeDialog";
import MultiplierDialog from "./MultiplierDialog";
import AddressInfoDialog from "./AddressInfoDialog";
import RGLimitDialogRaw from "./RGLimitDialogRaw";
import PlayerRiskCard from "./PlayerRiskCard";
import NotesList from "./NotesList";
import ContactInfo from "./ContactInfo";
import Transactions from "./Transactions";
import BetsCompetition from "./BetsCompetition";
import ReferFriendHistory from "./ReferFriendHistory";
import UserPackageTransaction from "./UserPackageTransaction";
import VipLevelInfo from "./VipLevelInfo";
import FreeSpins from "./FreeSpins";

// Compact coin balance tile — smaller than the shared MiniStat.
const CoinStat = ({ label, value, color }) => (
  <Box
    sx={{
      background: tokens.cardBg,
      border: `1px solid ${tokens.border}`,
      borderLeft: `3px solid ${color}`,
      borderRadius: "10px",
      p: "7px 11px",
    }}
  >
    <Typography sx={{ color: tokens.textDim, fontSize: 9.5, textTransform: "uppercase", letterSpacing: "0.07em", fontWeight: 600, whiteSpace: "nowrap" }}>
      {label}
    </Typography>
    <Typography sx={{ fontFamily: '"Space Grotesk", sans-serif', fontSize: 15, fontWeight: 600, mt: 0.2 }}>
      {value}
    </Typography>
  </Box>
);

// Label + value row with an optional edit affordance, used in the player panel.
const InfoRow = ({ label, children, onEdit }) => (
  <Box sx={{ display: "flex", alignItems: "center", py: 0.9, borderBottom: `1px solid ${tokens.border}`, "&:last-of-type": { borderBottom: "none" } }}>
    <Typography sx={{ fontSize: 10.5, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 700, color: tokens.textDim, width: 128, flexShrink: 0 }}>
      {label}
    </Typography>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", minWidth: 0, fontSize: 13 }}>{children}</Box>
    {onEdit && (
      <IconButton size="small" onClick={onEdit} sx={{ ml: "auto", color: tokens.textDim }} aria-label={`edit ${label}`}>
        <EditOutlinedIcon sx={{ fontSize: 15 }} />
      </IconButton>
    )}
  </Box>
);

const val = { fontSize: 13 };

const detailTabs = [
  { label: "Player" },
  { label: "Play Game List" },
  { label: "Transactions / Refer / Free Spins" },
  { label: "Risk & Responsible Gaming" },
  { label: "Package List" },
];

const UserDetails = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [userObject, setUserObject] = useState({});
  const params = useParams();

  const [detailTab, setDetailTab] = useState(0);

  const [accountDialog, setAccountDialog] = useState(false);
  const [accountValue, setAccountValue] = useState("");
  const [accountReason, setAccountReason] = useState("");
  const [openRGLimit, setOpenRGLimit] = useState(false);
  const [accountList, setAccountList] = useState([]);

  const [alldata, setalldata] = useState([]);
  const [addnote, setAddnote] = useState("");
  const [editData, setEditData] = useState({});

  const [accountTypeList] = useState([
    { account_status: "FINANCIAL", id: 0 },
    { account_status: "ADMIN", id: 1 },
    { account_status: "TESTUSER", id: 2 },
    { account_status: "OPERATOR", id: 3 },
    { account_status: "AGENCY", id: 4 },
    { account_status: "REALUSER", id: 5 },
    { account_status: "Casino User", id: 6 },
  ]);
  const [playerList, setPlayerList] = useState([]);
  const [playerDialog, setPlayerDialog] = useState(false);
  const [playerValue, setPlayerValue] = useState("");
  const [questionArr, setQuestionArr] = useState([]);
  const [questionValue, setQuestionValue] = useState("");
  const [ansValue, setAnsValue] = useState("");
  const [quesDailog, setQuesDialog] = useState(false);
  const [kycList, setKYCList] = useState([]);
  const [KYCDialog, setKYCDialog] = useState(false);
  const [kycValue, setKYCValue] = useState("");

  const [addressDialog, setAddressDialog] = useState(false);

  const [crsLimitDialog, setCRSLimitDialog] = useState(false);
  const [crsLimit, setCRSLimit] = useState("");
  const [dayLimitDialog, setDayLimitDialog] = useState(false);
  const [dailyLimit, setDailyLimit] = useState("");
  const [multiplierDialog, setMultiplierDialog] = useState(false);
  const [multiplierValue, setMultiplierValue] = useState("");

  const [userAccDialog, setUserAccDialog] = useState(false);
  const [userAccValue, setUserAccValue] = useState("");
  const state = useSelector((state) => state);

  const handleClose = (newValue, newReason) => {
    setAccountDialog(false);

    if (newValue) {
      setAccountValue(newValue);
      setAccountReason(newReason);
      let accountId = accountList.filter(
        (item) => item.account_status == newValue
      );
      let data = {
        idAccount: userObject.account?.idAccount,
        fieldValue: accountId[0]?.id,
        userId: userObject.account?.userId,
        fieldName: "status",
        reason: newReason,
      };
      UpdateAccountUser(data);
    }
  };

  const UpdateAccountUser = (data) => {
    let url = `${endPoints.api.fieldUpdate}`;
    setIsLoading(true);
    addData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          fetchUserData([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  const UpdateCommonInfo = (data) => {
    let url = `${endPoints.api.userFieldUpdate}`;
    setIsLoading(true);
    addData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          fetchUserData([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  const handleRGLimitClose = (newValue) => {
    setOpenRGLimit(false);
  };

  const handleDepositClick = async (data) => {
    if (data?.rg_limit_value && data?.time_period) {
      let url = `${endPoints.api.userRGLimit}`;
      setIsLoading(true);
      let result = await addData(url, data);
      if (result.data.status === "success") {
        SuccesToast(result?.data?.message);
        fetchUserData([]);
      }
      setOpenRGLimit(false);
      setIsLoading(false);
    }
  };

  const coolOffUserClick = async (data) => {
    let url = `${endPoints.api.COOL_OFF}`;
    if (data?.time_period) setIsLoading(true);
    let result = await addData(url, data);

    if (result.data.status === "success") {
      SuccesToast(result?.data?.message);
      fetchUserData([]);
    }
    setOpenRGLimit(false);
    setIsLoading(false);
  };

  const excludeUserClick = async (data) => {
    let url = `${endPoints.api.USER_EXCLUDE}`;
    setIsLoading(true);
    let result = await addData(url, data);

    if (result.data.status === "success") {
      SuccesToast(result?.data?.message);
      fetchUserData([]);
    }
    setOpenRGLimit(false);
    setIsLoading(false);
  };

  const handleBetClick = async (data) => {
    if (data?.rg_limit_value && data?.time_period) {
      let url = `${endPoints.api.userRGLimit}`;
      setIsLoading(true);
      let result = await addData(url, data);

      if (result.data.status === "success") {
        SuccesToast(result?.data?.message);
        fetchUserData([]);
      }
      setOpenRGLimit(false);
      setIsLoading(false);
    }
  };

  const handleAccountTypeClose = (newValue) => {
    setUserAccDialog(false);
    if (newValue) {
      setUserAccValue(newValue);
      let playerId = accountTypeList.filter((item) => item.id == newValue);

      let data = {
        LoginUserId: state.auth?.user?.data?.idUser,
        fieldValue: playerId[0]?.id,
        userId: userObject.account?.userId,
        fieldName: "type",
      };
      UpdateCommonInfo(data);
    }
  };

  const handlePlayerTypeeClose = (newValue) => {
    setPlayerDialog(false);
    if (newValue) {
      setPlayerValue(newValue);
      let playerId = playerList.filter((item) => item.player_type == newValue);

      let data = {
        idAccount: userObject.account?.idAccount,
        fieldValue: playerId[0]?.id,
        userId: userObject.account?.userId,
        fieldName: "player_type",
      };
      UpdateCommonInfo(data);
    }
  };

  const handleKycTypeClose = (newValue) => {
    setKYCDialog(false);
    if (newValue) {
      setKYCValue(newValue);
      let kycId = kycList.filter((item) => item.kyc_status == newValue);

      let data = {
        idAccount: userObject.account?.idAccount,
        fieldValue: kycId[0]?.id,
        userId: userObject.account?.userId,
        fieldName: "kyc_status",
      };
      UpdateCommonInfo(data);
    }
  };

  const handleQuestionClose = async (newValue, newValueAns) => {
    setQuesDialog(false);
    if (newValue || newValueAns) {
      setQuestionValue(newValue);
      setAnsValue(newValueAns);
      let question = questionArr.filter((item) => item.question == newValue);
      let data = {
        idUser: userObject?.idUser,
        login: userObject?.login,
        personalQuestion: question[0]?.question_id,
        personalResponse: newValueAns,
      };
      let url = `${endPoints.api.userSecret}`;
      setIsLoading(true);
      let result = await updateData(url, data);
      if (result.data.status === "success") {
        SuccesToast(result?.data?.message);
        fetchUserData([]);
      }
      setIsLoading(false);
    }
  };

  const handleCRSClose = async (newValue) => {
    setCRSLimitDialog(false);

    if (newValue) {
      setCRSLimit(newValue);
      let data = {
        userId: userObject?.idUser,
        login: userObject?.login,
        fieldValue: newValue,
        fieldName: "crs_limit",
      };
      UpdateCommonInfo(data);
    }
  };

  const handleDailyLimitClose = async (newValue) => {
    setDayLimitDialog(false);

    if (newValue) {
      setDailyLimit(newValue);
      let data = {
        userId: userObject?.idUser,
        login: userObject?.login,
        fieldValue: newValue,
        fieldName: "day_limit",
      };
      UpdateCommonInfo(data);
    }
  };

  const handleMultiplierClose = async (newValue) => {
    setMultiplierDialog(false);

    if (newValue) {
      setMultiplierValue(newValue);
      let data = {
        userId: userObject?.idUser,
        login: userObject?.login,
        idAccount: userObject?.account?.idAccount,
        fieldValue: newValue,
        fieldName: "multplier",
      };
      UpdateAccountUser(data);
    }
  };

  const handleResetUserStreak = async () => {
    if (
      !window.confirm(
        "Reset this user's Daily Streak? This clears their selected streak, current progress, and claim history. This cannot be undone."
      )
    ) {
      return;
    }
    setIsLoading(true);
    try {
      const url = `${endPoints.api.ADMIN_RESET_USER_STREAK}/${params.userId}`;
      const result = await addData(url);
      if (result?.data?.data?.status === "SUCCESS") {
        SuccesToast(result?.data?.data?.message || "Daily streak reset successfully.");
        fetchUserData([]);
      } else {
        ErrorToast(result?.data?.data?.message || "Failed to reset daily streak.");
      }
    } catch (error) {
      ErrorToast("Failed to reset daily streak.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddressClose = () => {
    setAddressDialog(false);
  };

  useEffect(() => {
    (async () => {
      let url = `${endPoints.api.GET_QUESTIONS}`;

      setIsLoading(true);
      let results = await getAllData(url);

      if (results.status === "success") {
        setQuestionArr(results.data);
        fetchUserData(results.data);
      }

      getPlayerTypes();
      getAccountStatus();
      getKycTypes();
      setIsLoading(false);
    })();
  }, []);

  const getKycTypes = () => {
    let url = `${endPoints.api.kycstatus}`;
    getAllData(url)
      .then((response) => {
        const { status, data } = response;
        if (status === "success") {
          setKYCList(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchUserData = async (questionList = []) => {
    let url = `${endPoints.api.GET_BY_USERID}/${params.userId}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        if (response.status === "success") {
          setUserObject(response.data);
          setAccountValue(response?.data?.accountStatus || "");
          setAccountReason(response?.data?.account?.reason || "");
          setPlayerValue(response?.data?.playerType || "");
          setKYCValue(response?.data?.kycStatus || "");
          setAnsValue(response?.data?.personalResponse || "");
          setMultiplierValue(response?.data?.multplier || "");
          setUserAccValue(response?.data?.type);
          let questionName = questionList.filter(
            (item) => item.question_id == response.data.personalQuestion
          );

          if (questionName) {
            setQuestionValue(questionName[0]?.question || "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  useEffect(() => {
    Getnotes();
  }, []);

  const Getnotes = async (data) => {
    let url = `${endPoints.api.GET_NOTES}/${params.userId}`;
    await getAllData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setalldata(response.data);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const DeleteNote = (id) => {
    setIsLoading(true);
    let url = `${endPoints.api.DELETE_NOTE}/${id}`;
    deleteData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast("Note Deleted Successfully.");
          Getnotes();
        } else {
          ErrorToast(response.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const getPlayerTypes = () => {
    let url = `${endPoints.api.playertypes}`;
    getAllData(url)
      .then((response) => {
        const { status, data } = response;
        if (status === "success") {
          setPlayerList(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAccountStatus = () => {
    let url = `${endPoints.api.accountstatus}`;
    getAllData(url)
      .then((response) => {
        const { status, data } = response;
        if (status === "success") {
          setAccountList(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const checkAccName = (id) => {
    switch (id) {
      case 0:
        return "FINANCIAL";
      case 1:
        return "ADMIN";
      case 2:
        return "TEST USER";
      case 3:
        return "OPERATOR";
      case 4:
        return "AGENCY";
      case 5:
        return "REAL USER";
      case 6:
        return "Casino USER";
      default:
        return id;
    }
  };

  const onClose = () => {
    setAddnote(false);
    Getnotes();
  };

  const isAdminLogin = state.auth?.user?.data?.type == 1;

  return (
    <Box>
      <Toaster></Toaster>
      {isLoading && <Loader spinner={true} visible={isLoading} />}

      <PageHeader
        title={`${userObject?.name || ""} ${userObject?.surname || ""}`.trim() || "Player Details"}
        crumb="Users / Player Details"
        subtitle={
          userObject?.login
            ? `${userObject.login} · #${userObject?.idUser}`
            : `#${params.userId}`
        }
      />

      <Grid container spacing={1.75} alignItems="flex-start">
        <Grid item xs={12}>
          <SectionCard sx={{ p: 0, overflow: "hidden" }}>
            <Tabs
              value={detailTab}
              onChange={(_, nextTab) => setDetailTab(nextTab)}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                borderBottom: `1px solid ${tokens.border}`,
                minHeight: 46,
                px: 1,
                "& .MuiTab-root": {
                  textTransform: "none",
                  minHeight: 46,
                  fontSize: 13,
                  fontWeight: 600,
                  color: tokens.textDim,
                },
                "& .Mui-selected": { color: tokens.primary },
                "& .MuiTabs-indicator": { backgroundColor: tokens.primary },
              }}
            >
              {detailTabs.map((tab) => (
                <Tab key={tab.label} label={tab.label} />
              ))}
            </Tabs>

            <Box
              sx={{
                p: 2,
                "& .MuiPaper-root.MuiTableContainer-root": { mt: 1 },
                "& .table-custom": { mt: "0 !important" },
              }}
            >
              {detailTab === 0 && (
                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", lg: "minmax(0,1.15fr) minmax(0,1fr)" }, gap: 1.75, alignItems: "start" }}>
                  <SectionCard
                    title="Player"
                    subtitle="Balances, statuses & profile"
                    sx={{ height: "auto" }}
                    action={userObject?.playerStatus ? pill(userObject.playerStatus, statusKind(userObject.playerStatus)) : null}
                  >
                    <Grid container spacing={1} sx={{ mb: 1.75 }}>
                      <Grid item xs={6}>
                        <CoinStat label="Gold Coin" value={userObject?.account?.gc_balance?.toFixed(2) ?? "—"} color={tokens.accent} />
                      </Grid>
                      <Grid item xs={6}>
                        <CoinStat label="Win Gold Coin" value={userObject?.account?.gc_main?.toFixed(2) ?? "—"} color={tokens.amber} />
                      </Grid>
                      <Grid item xs={6}>
                        <CoinStat label="Saga Coin" value={userObject?.account?.sc_credit?.toFixed(2) ?? "—"} color={tokens.secondary} />
                      </Grid>
                      <Grid item xs={6}>
                        <CoinStat label="Redeem Saga Coin" value={userObject?.account?.sc_main?.toFixed(2) ?? "—"} color={tokens.primary} />
                      </Grid>
                    </Grid>

                    <InfoRow label="Account Status" onEdit={() => setAccountDialog(true)}>
                      {accountValue ? pill(accountValue, statusKind(accountValue)) : "—"}
                    </InfoRow>
                    <InfoRow label="KYC Status" onEdit={() => setKYCDialog(true)}>
                      {kycValue ? pill(kycValue, statusKind(kycValue)) : "—"}
                    </InfoRow>
                    <InfoRow
                      label="Acc Type"
                      onEdit={
                        isAdminLogin
                          ? () => {
                              setUserAccDialog(true);
                              setUserAccValue(userObject?.type);
                            }
                          : undefined
                      }
                    >
                      <Typography sx={val}>{checkAccName(userObject?.type)}</Typography>
                    </InfoRow>
                    <InfoRow label="Player Type" onEdit={() => setPlayerDialog(true)}>
                      {playerValue ? pill(playerValue, "neutral") : "—"}
                    </InfoRow>
                    <InfoRow label="Play" onEdit={() => setMultiplierDialog(true)}>
                      <Typography sx={{ ...val, fontFamily: mono, fontWeight: 700 }}>
                        {userObject?.multplier ? `${userObject.multplier}x` : "—"}
                      </Typography>
                    </InfoRow>
                    <InfoRow label="DOB">
                      <Typography sx={{ ...val, fontFamily: mono }}>{userObject?.birthDate || "—"}</Typography>
                      {userObject?.sex && pill(userObject.sex, "neutral")}
                    </InfoRow>
                    <InfoRow label="State">
                      <Typography sx={val}>{userObject?.stateName || "—"}</Typography>
                    </InfoRow>
                    <InfoRow label="Daily Streak">
                      <Typography sx={val}>Day {userObject?.dailyReward?.currentDay ?? "—"}</Typography>
                      {userObject?.dailyReward?.currentDay != null &&
                        pill(userObject?.dailyReward?.claimed ? "Claimed" : "Not Claimed", userObject?.dailyReward?.claimed ? "ok" : "warn")}
                      <Button
                        size="small"
                        variant="outlined"
                        disabled={isLoading}
                        onClick={handleResetUserStreak}
                        sx={{ ml: 1, textTransform: "none", color: tokens.danger, borderColor: "rgba(242,92,102,0.4)" }}
                      >
                        Reset Streak
                      </Button>
                    </InfoRow>
                  </SectionCard>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1.75 }}>
                    <Box>
                      <VipLevelInfo userObject={userObject} />
                      <ContactInfo userObject={userObject} />
                    </Box>

                    <SectionCard
                      title="Notes"
                      sx={{ height: "auto" }}
                      action={
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => {
                            setAddnote(true);
                            setEditData([]);
                          }}
                          sx={{ textTransform: "none", color: tokens.secondary, borderColor: "rgba(35,214,160,0.4)" }}
                        >
                          Add Note
                        </Button>
                      }
                    >
                      <Box sx={{ maxHeight: 400, overflowY: "auto", overflowX: "hidden" }}>
                        <NotesList
                          alldata={alldata}
                          state={state}
                          setAddnote={setAddnote}
                          setEditData={setEditData}
                          DeleteNote={DeleteNote}
                        />
                      </Box>
                      <AddNote open={addnote} onClose={onClose} editData={editData} userid={userObject.account?.userId} />
                    </SectionCard>
                  </Box>
                </Box>
              )}
              {detailTab === 1 && <BetsCompetition userId={params.userId} />}
              {detailTab === 2 && (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                  <Transactions userId={params.userId} />
                  <Divider sx={{ borderColor: tokens.border }} />
                  <ReferFriendHistory userId={params.userId} />
                  <Divider sx={{ borderColor: tokens.border }} />
                  <FreeSpins userId={params.userId} />
                </Box>
              )}
              {detailTab === 3 && <PlayerRiskCard userId={params.userId} />}
              {detailTab === 4 && <UserPackageTransaction userId={params.userId} />}
            </Box>
          </SectionCard>
        </Grid>
      </Grid>

      <AccountStatusDialog
        id="ringtone-menu"
        keepMounted
        open={accountDialog}
        onClose={handleClose}
        value={accountValue}
        accountList={accountList}
        accountReason={accountReason}
      />
      <AccountTypeDialog
        keepMounted
        open={userAccDialog}
        onClose={handleAccountTypeClose}
        value={userAccValue}
        accountTypeList={accountTypeList}
      />
      <PlayerTypeDialog
        keepMounted
        open={playerDialog}
        onClose={handlePlayerTypeeClose}
        value={playerValue}
        playerList={playerList}
      />
      <KycTypeDialog
        keepMounted
        open={KYCDialog}
        onClose={handleKycTypeClose}
        value={kycValue}
        playerList={kycList}
      />
      <QuestionDialog
        keepMounted
        open={quesDailog}
        onClose={handleQuestionClose}
        value={questionValue}
        ansValue={ansValue}
        playerList={questionArr}
      />
      <CRSTypeDialog
        keepMounted
        open={crsLimitDialog}
        onClose={handleCRSClose}
        value={userObject?.betLimit?.crs_limit || crsLimit}
      />
      <DailyLimitTypeDialog
        keepMounted
        open={dayLimitDialog}
        onClose={handleDailyLimitClose}
        value={userObject?.betLimit?.day_limit || dailyLimit}
      />
      <MultiplierDialog
        keepMounted
        open={multiplierDialog}
        onClose={handleMultiplierClose}
        value={userObject?.multiplier || multiplierValue}
      />
      <AddressInfoDialog
        keepMounted
        open={addressDialog}
        onClose={handleAddressClose}
        userObject={userObject}
      />
      <RGLimitDialogRaw
        id="ringtone-menu"
        keepMounted
        open={openRGLimit}
        onClose={handleRGLimitClose}
        updateBet={handleBetClick}
        updateDeposit={handleDepositClick}
        userObject={userObject}
        coolOffUser={coolOffUserClick}
        excludeUser={excludeUserClick}
      />
    </Box>
  );
};

export default UserDetails;
